import React from "react";
import { SvgIcon, SvgIconProps } from "@mui/material";

export const CheckIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path fill="none" d="M15 5.36157L6.75 13.6116L3 9.86157" stroke="currentColor" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round"/>
    </SvgIcon>
  );
};